import { useMutation } from '@apollo/client';
import type { DeleteScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteScimDomainDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteScimDomainTRPC } from './useDeleteScimDomainTRPC';

type DeleteScimDomainInput = { domain: string };

export const useDeleteScimDomain = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteScimDomainGraphQL, graphqlState] = useMutation(
    DeleteScimDomainDocument,
    {
      update: (cache) => {
        evictField(cache, 'getScimConfig');
      },
    }
  );

  const trpcMutation = useDeleteScimDomainTRPC();

  const deleteScimDomain = async (
    variables: DeleteScimDomainInput
  ): Promise<DeleteScimDomainMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteScimDomain(variables);
    }

    const result = await deleteScimDomainGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to delete SCIM domain');
    }

    return result.data;
  };

  return {
    deleteScimDomain,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
